export default __webpack_public_path__ + "static/404_image-346cf9d9359084f891ab036a1c85f014.jpg";